module.exports = __webpack_public_path__ + "media/images/emblems/Muenchwilen-Blazono-3c3ce589382d7c70b9cc59994736e34d.png";